export enum ChainId {
    MAINNET = 204,
    BSCTESTNET = 5611
}
export default { ChainId }
